import jQuery from 'jquery';
import * as segmentio from 'rp-analytics';
import { skybetDiffusionName } from '../helpers/utils';

const configBookieNames = {
    williamHill: 'William Hill',
    ladbrokes: 'Ladbrokes',
    bet365: 'bet365',
    paddypower: 'Paddy Power',
    betfair: 'Betfair',
    coral: 'Coral',
    [skybetDiffusionName]: 'Skybet'
};

export default class PredictorHandler {
    constructor(customConfig) {
        const defaultConfig = {
            defaultBookie: 'williamHill',
            iframeSelector: '.js-RC-predictor__frame',
            openBtnSelector: '.js-RC-predictor__openBtn',
            closeBtnSelector: '.js-RC-predictor__closeBtn',
            feedBookieMap: {
                WH_OXI: 'williamHill',
                '#BESTODDS': 'bestOdds',
                LADB: 'ladbrokes',
                BET365: 'bet365',
                CORAL: 'coral',
                PPWR: 'paddypower',
                BETFAIR: 'betfair',
                VC: 'betVictor',
                // 'SPORTING INDEX': 'sportingBet',
                [skybetDiffusionName]: 'skybet',
                BOLEYSPORTS: 'boylesport',
                TOTE: 'tote'
            }
        };
        this.config = jQuery.extend(true, defaultConfig, customConfig);
        this.iframe = null;
        this.urlPattern = '';
        this.bookmaker = '';
        this.decimalOdds = false;
        this.bookmaker = this.config.defaultBookie;
        this.init();
    }

    init() {
        this.bindEvents();
        this.iframe = document.querySelector(this.config.iframeSelector);
        if (this.iframe) {
            this.urlPattern = this.iframe.getAttribute('data-url-pattern');
        }
    }

    bindEvents() {
        jQuery(document).on('bookieChanged.BOOKMAKER', this.onBookieChanged.bind(this));
        jQuery(document).on('userSettingsChanged.SETTINGS', this.onUserSettingsChanged.bind(this));

        jQuery(this.config.openBtnSelector).on('click', this.onFrameOpen.bind(this));
        jQuery(this.config.closeBtnSelector).on('click', this.onFrameClose.bind(this));

        document.addEventListener('SEGMENTIO.TRACK_PREDICTOR', this.trackOddsButtonClick.bind(this));
    }

    trackOddsButtonClick() {
        const bookieName = configBookieNames[this.bookmaker];
        const config = {
            [segmentio.TRAIT_BOOKMAKER]: bookieName,
            [segmentio.TRAIT_LOCATION]: 'Predictor'
        };

        segmentio.identify(undefined, config)
            .then(() => segmentio.trackBetButtonClick(config));
    }

    onBookieChanged(event, feedBookieName) {
        const bookmaker = this.getBookieName(feedBookieName);

        if (this.bookmaker !== bookmaker || (this.iframe && this.iframe.getAttribute('src') === null)) {
            this.bookmaker = bookmaker;
        }
    }

    onUserSettingsChanged(event, userSettings) {
        if (this.decimalOdds !== userSettings.decimalOdds) {
            this.decimalOdds = userSettings.decimalOdds;
        }
    }

    onFrameOpen() {
        if (this.iframe && this.urlPattern) {
            const url = this.urlPattern
                .replace('[$bookmaker]', this.bookmaker)
                .replace('[$prices]', (this.decimalOdds ? 'decimal' : 'fractional'));

            this.iframe.setAttribute('src', url);
        }
    }

    onFrameClose() {
        this.iframe.removeAttribute('src');
    }

    getBookieName(feedBookieName) {
        return this.config.feedBookieMap[feedBookieName] || this.config.defaultBookie;
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/predictorHandler.js